import { useCallback, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { actions } from 'store'

const useOnPause = () => {
    const dispatch = useDispatch()
    const { wavesurfer, isPlaying } = useSelector(state => state.wavesurfer)

    const isPlayingRef = useRef(isPlaying);
    const wavesurferRef = useRef(wavesurfer);

    useEffect(() => {
        isPlayingRef.current = isPlaying;
    }, [isPlaying])

    useEffect(() => {
        wavesurferRef.current = wavesurfer;
    }, [wavesurfer])

    const onPause = useCallback(() => {
        if (isPlayingRef.current) {
            dispatch(actions.setIsPlaying(false))
            if (wavesurferRef.current)
                wavesurferRef.current.pause()
        }
    }, [])

    return onPause
}

export default useOnPause 